import { html, css } from 'lit-element';
import { TmnConfirmationToolBase } from '@trumedianetworks/tmn-core-components/src/tmn-tool-base';

class TableActionConfirmation extends TmnConfirmationToolBase {
    constructor() {
        super();
        this.disabled = false;
        // this.buttonColor = 'error';
        // this.controlType = 'icon-button';
        this.confirmMessage = 'Are you sure?';
    }

    static get styles() {
        return [
            super.styles,
            css`
                .modal-content {
                    padding: 12px;
                    width: 325px;
                }
            `,
        ];
    }

    static get properties() {
        return {
            disabled: {
                type: Boolean,
            },
            displayName: {
                type: String,
            },
            eventData: {
                type: Object,
            },
            confirmMessage: {
                type: String,
            },
        };
    }

    getButtonLabel() {
        return 'Confirm';
    }

    getToolTitle() {
        return 'Confirm Action';
    }
    // override the input b/c we will show this based on external actions
    renderToolInput() {
        return null;
    }

    getConfirmationLabel() {
        //const { displayName } = this;
        return `${this.confirmMessage}`;
    }

    getConfirmButtonLabel() {
        return html`<span>Continue without saving</span>`;
    }

    _handleConfirm(e) {
        // could pass in actions as an alternative
        const { eventData } = this;
        const event = new CustomEvent('tmn-action-confirmed', {
            detail: {
                ...eventData,
            },
        });
        this.dispatchEvent(event);
        this._toggleDialog();
    }
}

window.customElements.define('table-action-confirmation', TableActionConfirmation);
